import * as React from 'react';
import { observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import AuditionImageStore from '@src/pages/audition-image/store';
import Page from '../../components/page';
import cx from 'classnames';
import Link from '@src/components/link';
import SimpleSwiper from '@src/components/swiper/simple-swiper';
import CommonHeader from '@src/business-components/common-header';
import CommonFooterModal from '@src/business-components/common-footer-modal';

const styles = require('./index.less');

const AuditionImage = () => {
  const store = useStore(() => new AuditionImageStore());
  return (
    <Page className={styles.root}>
      <CommonHeader store={store.commonHeaderStore} />
      <div className={styles.feature}>
        <div className={styles.featureImg}>
          {/* {store.showFeature && (
            <SimpleSwiper params={store.paramsImg} key={store.images.length}>
              {store.images.map((item, index) => <img className={cx(styles.img)} key={index} src={item.img} alt={item.title} />)}
            </SimpleSwiper>
          )} */}
          {store.images.map((item, index) => (
            <img className={cx(styles.img, store.currentIndex === index && styles.active)} key={index} src={item.img} alt={item.title} />
          ))}
        </div>
        <div className={styles.content}>
          <div className={styles.backContent}>
            <Link className={styles.back} onClick={() => store.goBack()} />
          </div>
          <div className={styles.featureSwiper}>
            {store.images.length >= 5 ? (
              <SimpleSwiper params={store.params} key={store.images.length}>
                {store.images.map((item, index) => (
                  <div className={styles.swiperItem} key={index}>
                    <img src={item.thumbImg} alt={item.title} />
                  </div>
                ))}
              </SimpleSwiper>
            ) : (
              <div className={styles.featureSwiperBox}>
                {store.images.map((item, index) => (
                  <div
                    className={cx(styles.swiperItem, store.currentIndex === index && 'swiper-slide-active')}
                    key={index}
                    onClick={() => store.changeIndex(index)}
                  >
                    <img src={item.thumbImg} alt={item.title} />
                  </div>
                ))}
              </div>
            )}
            {store.images.length >= 5 && (
              <div className={styles.swiperAction}>
                <Link className={cx(styles.swiperBtn, styles.prev)} onClick={() => store.changeSwiper('prev')} />
                <Link className={cx(styles.swiperBtn, styles.next)} onClick={() => store.changeSwiper('next')} />
              </div>
            )}
          </div>
        </div>
        <CommonFooterModal />
      </div>
    </Page>
  );
};

export default observer(AuditionImage);
